import { SHOP_MULTILPE } from "arv-extends/constants";

SHOP_MULTILPE.SHOP_ALL_STYLES.ADD_TO_BAG_TEXT = "ADD TO CART";
SHOP_MULTILPE.SHOP_ALL_STYLES.ADD_TO_BAG_SUCCESS =
  "Yay! We've added the items to your cart.";
export default SHOP_MULTILPE;
